module.exports = __webpack_public_path__ + "static/media/RealTimeCommunication_Elec_004.f6fdc56a.png";